import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";


export const downloadReport = async (data) => {
  try {
    const response = await gatewayInstance.get(
      `/reportingservice/report/downloadReport`,
      {
        params: data,
      },
    );
    return response.data;
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data;
    }
    console.error(e);
    throw e;
  }
};
export const reportTypeDropdown = async (moduleCat) => {
  try {
    const response = await gatewayInstance.get(`/reportingservice/report`, {
      params: {
        moduleCategory: moduleCat,
      },
    });
    return response.data.map((item) => ({
      ...item,
      key: item.reportSeq,
      text: item.displayName,
      value: item.reportSeq,
      reportSeq: item.reportSeq,
      companyProfileSeq: item.companyProfileSeq,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const downloadExcelReport = async (data) => {
  const params = new URLSearchParams(data).toString();
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/report/downloadExcelReports?${params}`,
      null,
      {
        responseType: "json",
      },
    );
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const downloadMultipleReports = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/reportingservice/report/download-multiple-Reports`,
      data,
    );

    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const createReleaseNote = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/release-note`,
      data
    );
    return response.data;
  } catch (e) {
    console.error("createReleaseNote error", e);
    throw e;
  }
};

export const getLatestReleaseNote = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/release-note`
    );

    console.log("RAW API RESPONSE:", response.data);

    const list = response.data || [];

    if (!list.length) return null;

    const sorted = list.sort(
      (a, b) => new Date(b.releaseDate) - new Date(a.releaseDate)
    );

    return sorted[0]; // latest
  } catch (e) {
    console.error("getLatestReleaseNote error", e);
    return null;
  }
};

export const getAllReleaseNotes = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/release-note`
    );

    const data = response.data || [];
    //  sort latest first
    const sorted = data.sort(
      (a, b) => new Date(b.releaseDate) - new Date(a.releaseDate)
    );

    const latestFive = sorted.slice(0, 50);
    return latestFive;
  } catch (e) {
    return [];
  }
};

export const checkPickupKpiExceeded = async (jobId, stakeholderId) => {
  try {
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.TRANSPORT}/job/pickup-kpi/check`,
        {
          params: { jobId, stakeholderId },
        }
    );
    return response.data?.[0] ?? null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const updateJobField = async (jobId, pickupDemurrageReason) => {
  try {
    const response = await gatewayInstance.put(
        `${SERVICE_ENDPOINT.TRANSPORT}/job`,
        {
          jobId: jobId,
          updateMap: {
            jobPickupDemurrageReason: pickupDemurrageReason,
          },
        }
    );
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
